import StatusDetail from "./StatusDetail.vue";
import Integration from "./Integration.vue";
import api from "@api";
import { mapState } from "vuex";
import Detail from "./Detail.vue";

export default {
  name: `NawalaList`,
  components: { StatusDetail, Integration, Detail },
  props: {
    clientCode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      newSlotCount: null,
      search: null,
      selectedRow: null,
      editingRow: null,
      table: {
        items: [],
        fields: [
          { key: "select", label: "", onlyAdmin: true, thStyle: `width: 40px` },
          {
            key: "description",
            label: `Description`,
            filterable: true,
            sortable: true,
          },
          {
            key: "domain",
            label: `URL`,
            sortable: true,
            filterable: true,
          },
          {
            key: "status",
            label: `Status`,
            class: `text-right`,
            sortable: true,
          },
          {
            key: `integration`,
            label: `Integration`,
            class: `text-right`,
            sortable: false,
          },
          {
            key: "action",
            label: "",
            class: `text-right`,
            thClass: `action-column`,
            tdClass: `action-column`,
          },
        ],
        paging: {
          pageNo: 1,
          pageSize: 10,
        },
        selectedRows: [],
        isSelectAll: false,
      },
      statusList: [
        { value: null, text: "All Status" },
        { value: "BLOCKED", text: "BLOCKED" },
        { value: "SAFE", text: "SAFE" },
        { value: "FORBIDDEN", text: "FORBIDDEN" },
      ],
      filter: {
        description: null,
        domain: null,
        status: null,
      },
      modal: { status: false, detail: false, integration: false },
      loader: false,
    };
  },
  computed: {
    ...mapState(`auth`, [`user`]),
    computedFields() {
      return this.table.fields.filter(x => !x.onlyAdmin || (x.onlyAdmin && this.$can(`super`, `nawala`)));
    },
    filteredItems() {
      let items = this.table.items;
      if (this.filter.description) {
        items = items.filter(
          x => x.description && x.description.toLowerCase().includes(this.filter.description.toLowerCase()),
        );
      }

      if (this.filter.domain) {
        items = items.filter(x => x.domain && x.domain.toLowerCase().includes(this.filter.domain.toLowerCase()));
      }

      if (this.filter.status) {
        items = items.filter(x => x.status == this.filter.status);
      }
      return items;
    },
  },
  watch: {
    "table.isSelectAll": function (val) {
      this.checkAll(val);
    },
  },
  async mounted() {
    await this.loadData();

    this.refreshTimer = setInterval(() => {
      this.refreshData();
    }, 60000);
  },
  methods: {
    async loadData() {
      this.loader = true;
      try {
        if (this.clientCode) this.table.items = await api.get(`slot/${this.clientCode}`);
        else this.table.items = await api.get(`slot/${this.user.clientCode}`);
      } catch (error) {
        this.showToast(`error`, error);
      } finally {
        this.loader = false;
      }
    },
    async refreshData() {
      try {
        var data;
        if (this.clientCode) data = await api.get(`slot/${this.clientCode}`);
        else data = await api.get(`slot/${this.user.clientCode}`);
        if (data == this.table.items) return;
        this.table.items = data;
      } catch (error) {
        console.error(error);
      } finally {
      }
    },
    async addNewSlot() {
      let confirmed = await this.showConfirm(`Add New ${this.newSlotCount} Slot?`);
      if (!confirmed) return;
      this.loader = true;
      try {
        await api.post(`slot`, {
          clientCode: this.clientCode,
          newSlotCount: this.newSlotCount,
          username: this.user.email,
        });
        this.loadData();
      } catch (error) {
        this.showToast(`error`, error);
      } finally {
        this.loader = false;
      }

      this.showToast(`success`, `${this.newSlotCount} Slot Added`);
      this.newSlotCount = null;
    },

    modify(row) {
      this.selectedRow = { ...row };
      this.modal.detail = true;
    },

    saveSuccess() {
      this.loadData();
      this.modal.detail = false;
    },

    async remove(row) {
      let confirmed = await this.showConfirm(`Remove Slot ?`);
      if (!confirmed) return;
      this.loader = true;
      try {
        await api.delete(`slot/${row.code}`);
        this.showToast(`success`, `Slot Removed`);
        this.loadData();
      } catch (error) {
        this.showToast(`error`, error);
      } finally {
        this.loader = false;
      }
    },

    async removeBatch() {
      let confirmed = await this.showConfirm(`Remove All Selected Slot ?`);
      if (!confirmed) return;
      this.loader = true;
      try {
        await api.put(`slot/remove-batch`, { slotCodeList: this.table.selectedRows });
        this.showToast(`success`, `Slot Removed`);
        this.loadData();
      } catch (error) {
        this.showToast(`error`, error);
      } finally {
        this.loader = false;
      }
    },

    async toggle(row) {
      var message = "";
      if (row.isActive == true) {
        message = `Deactivate this Slot ?`;
      } else {
        message = `Activate this Slot ?`;
      }
      let confirmed = await this.showConfirm(message);
      if (!confirmed) return;
      this.loader = true;
      try {
        await api.put(`slot/toggle/`, { code: row.code, username: this.user.email });
        this.showToast(`success`, `Slot IsActive Changed`);
        this.loadData();
      } catch (error) {
        this.showToast(`error`, error);
      } finally {
        this.loader = false;
      }
    },

    openIntegration(row) {
      this.selectedRow = { ...row };
      this.modal.integration = true;
    },

    async showStatus(row) {
      this.selectedRow = { ...row };
      this.modal.status = true;
    },

    checkAll(val) {
      if (val) {
        this.table.selectedRows = this.table.items.map(x => x.code);
      } else {
        this.table.selectedRows = [];
      }
    },

    variantRotator(status) {
      switch (status) {
        case "BLOCKED":
          return "danger";
        case "SAFE":
          return "success";
        case "FORBIDDEN":
          return "warning";
        default:
          return "secondary";
      }
    },

    customSort(a, b, key, sortDesc) {
      // Extract the sort values from the items
      let aVal = a[key];
      let bVal = b[key];

      // Determine if the values are empty (null, undefined or blank string)
      const isEmpty = val => val === null || val === undefined || (typeof val === "string" && val.trim() === "");
      const aEmpty = isEmpty(aVal);
      const bEmpty = isEmpty(bVal);

      // If one value is empty and the other is not, always push the empty one to the bottom
      if (aEmpty && !bEmpty) return 1;
      if (!aEmpty && bEmpty) return -1;
      if (aEmpty && bEmpty) return 0;

      // For non-empty values, use localeCompare for ascending or descending
      if (sortDesc) {
        return String(bVal).localeCompare(String(aVal));
      } else {
        return String(aVal).localeCompare(String(bVal));
      }
    },
  },
};
